import { api } from '../api';
import { LoginForm, LoginResponse } from '../../interfaces/api/auth/login';
import axios from 'axios';
import http from '../http';

/**
 * Interface for profession update request
 * @interface UpdateProfessionRequest
 */
interface UpdateProfessionRequest {
  /** ID of the profession to update to */
  profession_id: number;
}

/**
 * Authentication service
 * Provides methods for user authentication and profile management
 */
export const auth = {
  /**
   * Authenticates a user with credentials
   * @param {LoginForm} body - User login credentials
   * @returns {Promise<LoginResponse>} Promise resolving to login response with user data and token
   */
  login: (body: LoginForm): Promise<LoginResponse> =>
    new Promise((resolve, reject) => {
      axios
        .post(api.auth.login, body)
        .then((res) => resolve(res?.data as LoginResponse))
        .catch((e) => reject(e));
    }),

  /**
   * Updates the profession of the authenticated user
   * @param {UpdateProfessionRequest} body - Contains the profession ID to update to
   * @returns {Promise<LoginResponse>} Promise resolving to updated user data
   */
  updateProfession: (body: UpdateProfessionRequest): Promise<LoginResponse> =>
    new Promise((resolve, reject) => {
      http
        .put(api.auth.updateProfession, body)
        .then((res) => resolve(res as LoginResponse))
        .catch((e) => reject(e));
    }),
};
